module.exports = __webpack_public_path__ + "static/google-keep-79b75fa3f9d82f8c4c703a9525dbe494.svg";